/* Startseite: Kundenlogos (snippets/cm-x-home-logos.liquid) — Fassung 2: Logo-Wand mit sanftem Wechsel.
   Ohne dieses Skript steht das Raster mit allen Logos. Mit Skript: Die Wand zeigt Spalten × Zeilen Kacheln
   (--cmx-hl-cols / --cmx-hl-rows aus dem CSS). Logo i liegt in Kachel i mod Kachelzahl; die ersten Logos sind sichtbar,
   die übrigen teilen sich die Kacheln. Alle paar Sekunden wechselt EINE Kachel ihr Logo (CSS-Übergang).
   Pause: Knopf, Maus über der Wand, außerhalb des Sichtfelds, Fenster im Hintergrund.
   Bei „Bewegung reduzieren“ wird nichts gebaut bzw. zum Raster zurückgebaut. */
(function () {
  'use strict';
  var TAKT = 2400;      // ms zwischen zwei Wechseln
  var ANLAUF = 2600;    // ms bis zum nächsten Wechsel, nachdem die Wand (wieder) ins Sichtfeld kommt
  var AUS = 700;        // ms, bis ein ausgeblendetes Logo wieder „unten“ bereitsteht (länger als der CSS-Übergang)

  function init(root) {
    if (root.cmxHlReady) return;
    root.cmxHlReady = true;
    var list = root.querySelector('.cmx-hl-list');
    var btn = root.querySelector('.cmx-hl-pause');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var live = false, n = 0, cols = 0, shown = [], order = [], step = 0, timer = null, io = null;
    var paused = false, hover = false, near = !('IntersectionObserver' in window);

    function cells() {
      var cs = getComputedStyle(root);
      var cols = parseInt(cs.getPropertyValue('--cmx-hl-cols'), 10) || 0;
      var rows = parseInt(cs.getPropertyValue('--cmx-hl-rows'), 10) || 0;
      return { cols: cols, n: cols * rows };
    }

    // Reihenfolge der Kacheln: springt durch die Wand, damit nie zwei Nachbarn nacheinander wechseln
    function makeOrder(count) {
      var s = 1, c = [5, 7, 3, 11, 13], i, k, gcd = function (a, b) { return b ? gcd(b, a % b) : a; };
      for (i = 0; i < c.length; i++) if (c[i] < count && gcd(c[i], count) === 1) { s = c[i]; break; }
      var out = [];
      for (k = 0; k < count; k++) out.push((k * s) % count);
      return out;
    }

    function layout() {
      root.classList.add('is-live');           // erst die Klasse: sie kann Spalten/Zeilen ändern
      var c = cells();
      if (!c.n || items.length <= c.n) { teardown(); return; }   // alles passt ohnehin: Raster bleibt
      if (live && c.n === n && c.cols === cols) return;
      n = c.n; cols = c.cols;
      root.classList.add('is-setup');
      items.forEach(function (li, i) {
        var cell = i % n;
        li.style.gridColumn = String((cell % c.cols) + 1);
        li.style.gridRow = String(Math.floor(cell / c.cols) + 1);
        li.classList.toggle('is-base', i < n);
        li.classList.toggle('is-on', i < n);
        li.classList.remove('is-out');
      });
      shown = [];
      for (var k = 0; k < n; k++) shown.push(k);
      order = makeOrder(n);
      step = 1;                                // die erste Kachel wechselt zuletzt
      live = true;
      void list.offsetWidth;                   // Ausgangslage ohne Übergang setzen
      root.classList.remove('is-setup');
      if (btn) btn.hidden = false;
      setPaused(paused);
      if (!io && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          near = entries[entries.length - 1].isIntersecting;
          if (near) items.forEach(function (li) { var img = li.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; });
          plan(ANLAUF);
        }, { rootMargin: '0px 0px -10% 0px' });
        io.observe(list);
      }
      plan(ANLAUF);
    }

    function teardown() {
      clearTimeout(timer); timer = null;
      if (io) { io.disconnect(); io = null; near = !('IntersectionObserver' in window); }
      items.forEach(function (li) {
        li.style.gridColumn = ''; li.style.gridRow = '';
        li.classList.remove('is-base', 'is-on', 'is-out');
      });
      root.classList.remove('is-live', 'is-setup', 'is-paused');
      live = false; n = 0; cols = 0;
      if (btn) btn.hidden = true;
    }

    function plan(ms) {
      clearTimeout(timer); timer = null;
      if (!live || paused || hover || !near || document.hidden) return;
      timer = setTimeout(tick, ms);
    }

    function tick() {
      timer = null;
      if (!live) return;
      for (var tries = 0; tries < n; tries++) {
        var cell = order[step % n]; step++;
        var cur = shown[cell];
        var next = cur + n < items.length ? cur + n : cell;      // nächstes Logo dieser Kachel, am Ende wieder das erste
        if (next === cur) continue;
        var img = items[next].querySelector('img');
        if (img && !(img.complete && img.naturalWidth > 0)) { img.loading = 'eager'; continue; }   // noch nicht geladen: später
        swap(cell, cur, next);
        break;
      }
      plan(TAKT);
    }

    function swap(cell, cur, next) {
      var a = items[cur], b = items[next];
      a.classList.remove('is-on'); a.classList.add('is-out');
      b.classList.remove('is-out'); b.classList.add('is-on');
      shown[cell] = next;
      setTimeout(function () { if (!a.classList.contains('is-on')) a.classList.remove('is-out'); }, AUS);
    }

    function setPaused(on) {
      paused = on;
      root.classList.toggle('is-paused', on);
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute(on ? 'data-play' : 'data-pause') || '');
      }
      plan(on ? 0 : 900);
    }

    if (btn) btn.addEventListener('click', function () { setPaused(!paused); });
    list.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; plan(0); } });
    list.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; plan(900); } });
    document.addEventListener('visibilitychange', function () { plan(ANLAUF); });

    function sync() { if (mq && mq.matches) teardown(); else layout(); }
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq.addListener) mq.addListener(sync);
    }
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sync, 150); });
    sync();
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-cmx-hl]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
